
$.agito = $.agito || {};
$.agito.codelistConstants = $.agito.codelistConstants || {};

$.agito.codelistConstants.Entity_HRM_Addendum = 'A3309759-2E4A-4E1F-8495-1D18E3A2644F';
$.agito.codelistConstants.Entity_HRM_LegalDocument = '245036EF-CABE-4389-AA40-3F85F175B44F';

$.agito.codelistConstants.FormGroup_Addendum_Deactivate = '58363A53-EB86-4745-9C51-1FA34F1BCD72';
$.agito.codelistConstants.FormGroup_Job_Deactivate = '6D203EB6-FF6A-461D-92B5-E80344A08A11';
$.agito.codelistConstants.FormGroup_LegalDocument_Deactivate = 'D24AE3B0-C260-4B75-B367-D8BB24AB675B';
$.agito.codelistConstants.FormGroup_OrganizationUnit_Deactivate = '23DD4830-0778-4AA8-B7A5-A0FEDC2D81CC';

//$.agito.codelistConstants.DashboardWidget_ReportGrid = 'grid'; // todo
//$.agito.codelistConstants.DashboardWidget_ReportChart = 'chart'; // todo
//$.agito.codelistConstants.DashboardWidget_ReportPieChart = 'piechart'; // todo